export const UserRoles = {
  SUPER_ADMIN: 'superAdmin',
  ADMIN: 'admin',
  ECO: 'eco',
  USER: 'user',
  SUBSCRIBER_BTOB: 'subscriberBtoB',
  SUBSCRIBER_BTOC: 'subscriberBtoC',
  CONCIERGERIE: 'conciergerie',
  CONTACT: 'contact',
  ENTREPRISE: 'entreprise',
} as const;

export type UserRole = typeof UserRoles[keyof typeof UserRoles];
